import { Component, Input, OnInit } from '@angular/core';
// import { Message } from 'primeng/api';
import type { ToastMessageOptions } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MessageModule } from 'primeng/message';


@Component({
  selector: 'app-blurb',
  templateUrl: './blurb.component.html',
  styleUrls: ['./blurb.component.scss'],
  imports: [CommonModule, MessageModule]
})
export class BlurbComponent implements OnInit {

  @Input() message: string;
  @Input() severity = 'info';
  _messages: ToastMessageOptions[];
  hideBlurb: boolean = false;

  constructor(
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this._messages = [
      {
        severity: this.severity,
        detail: null,
      },
    ];

    this.translate.onLangChange.subscribe(() => {
      this.hideBlurb = true;
      setTimeout(() => {this.getMessages(); this.hideBlurb = false;});
    });
  }

  getMessages(): ToastMessageOptions[] {
    if (this._messages.length && this.message) {
      this._messages[0].detail = this.getTranslation(this.message);
    }
    return this._messages;
  }

  set messages(val: ToastMessageOptions[]) {
    this._messages = val;
  }

  private getTranslation(key: string): string {
    return  key && this.translate.instant(key) !== key ? this.translate.instant(key) : '';
  }

}
